export default __webpack_public_path__ + "static/media/shopifyNativeConcent4.88b3e4d3.svg";